import {useState , useEffect} from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useLoginMutation, useRegisterMutation } from '../../app/config/redux/slices/api/userApiSlice';
import { setCredentials } from '../../app/config/redux/slices/authSlice';
import AlertMessage from './AlertMessage';

const Account = () => {

    const[name,setName]=useState('');
    const [mobile, setMobile] = useState('');
    const [password, setPassword] = useState('');
    const [registerMobile, setRegisterMobile] = useState('');
    const [registerPassword, setRegisterPassword] = useState('');
    const [confirmPassword,setConfirmPassword]=useState('');
    const [alert, setAlert] = useState(null);
    const [errors, setErrors] = useState({});

    const dispatch = useDispatch();
    const navigate = useNavigate(); 

    const [login , {isLoading}]  = useLoginMutation();
    const [register,{ isLoadingReg }] = useRegisterMutation();
    const {userInfo} = useSelector((state) => state.auth);


    const performLogin = async ({ mobile, password }, login, dispatch, setAlert, navigate, setErrors) => {
        try {
            const res = await login({ mobile, password }).unwrap();

            const userInfo = {
                id: res.user.id,
                username: res.user.username,
                name: res.user.name,
                access_token: res.access_token,
            };

            dispatch(setCredentials(userInfo));
            setAlert({ type: 'success', message: `hi ${res.user.name}` });

            setTimeout(() => {
                setAlert(null);
            }, 3000);

            navigate('/');
        } catch (error) {
            setAlert({ type: 'danger', message: error?.data?.message || error.error });

            setTimeout(() => {
                setAlert(null);
            }, 3000);

            setErrors(error?.data?.errors || {});
        }
    };

    const loginSubmitHandler = async (e) => {
        e.preventDefault();
        setErrors({});
        await performLogin({ mobile, password }, login, dispatch, setAlert, navigate, setErrors);
    };


    
    const registerSubmitHandler = async (e) => {
        e.preventDefault();
        if(registerPassword !== confirmPassword){
            setAlert({ type: 'danger', message: "Passwords do not match. Please try again." });

            setErrors({
                confirmPassword: ["Passwords do not match."],
                registerPassword: ["Passwords do not match."]

            });
            setTimeout(() => {
              setAlert(null); // Auto close after 3s
            }, 3000);
            return;
        }else{
            try{
                const res = await register({name,mobile: registerMobile, password: registerPassword}).unwrap();
                 dispatch(setCredentials(userInfo));
                setAlert({ type: 'success', message: res.message });

                setTimeout(() => {
                    setAlert(null); // Auto close after 3s
                }, 3000);
                await performLogin({ mobile: registerMobile, password: registerPassword }, login, dispatch, setAlert, navigate, setErrors)
            }catch(error){
                setAlert({ type: 'danger', message: error?.data?.message || error.error });

                setTimeout(() => {
                setAlert(null); // Auto close after 3s
                }, 3000);
                setErrors(error?.data?.errors || {});
            }
        }
        
    };

    return (
        <section className="account py-80">
            {alert && (
                <AlertMessage
                message={alert.message}
                type={alert.type}
                onClose={() => setAlert(null)}
                />
            )}
            <div className="container container-lg">
    
                    <div className="row gy-4">
                        {/* Login Card Start */}

                        <div className="col-xl-6 pe-xl-5">
                            <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40 h-100">
                                <h6 className="text-xl mb-32">Login</h6>
                                <form onSubmit={loginSubmitHandler}>
                                    <div className="mb-24">
                                        <label
                                            htmlFor="username"
                                            className="text-neutral-900 text-lg mb-8 fw-medium"
                                        >
                                            Mobile Number <span className="text-danger">*</span>{" "}
                                        </label>
                                        <input
                                            type="text"
                                            className="common-input is-invalid"
                                            id="username"
                                            placeholder="Enter your mobile number"
                                            value={mobile}
                                            onChange={(e) => setMobile(e.target.value)}
                                        />
                                        {errors.mobile && <div className="invalid-feedback">{errors.mobile && errors.mobile[0]}</div>}
                                    </div>
                                    <div className="mb-24">
                                        <label
                                            htmlFor="password"
                                            className="text-neutral-900 text-lg mb-8 fw-medium"
                                        >
                                            Password
                                        </label>
                                        <div className="position-relative">
                                            <input
                                                type="password"
                                                className="common-input is-invalid"
                                                id="password"
                                                placeholder="Enter your password"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                            />
                                            <span
                                                className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ph-eye-slash"
                                                id="#password"
                                            />
                                        </div>
                                    </div>
                                    <div className="mb-24 mt-48">
                                        <div className="flex-align gap-48 flex-wrap">
                                            <button type="submit" className="btn btn-main py-18 px-40">
                                                Log in
                                            </button>
                                            <div className="form-check common-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    defaultValue=""
                                                    id="remember"
                                                />
                                                <label
                                                    className="form-check-label flex-grow-1"
                                                    htmlFor="remember"
                                                >
                                                    Remember me
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-48">
                                        <Link
                                            to="/password"
                                            className="text-danger-600 text-sm fw-semibold hover-text-decoration-underline"
                                        >
                                            Forgot your password?
                                        </Link>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {/* Login Card End */}
                        {/* Register Card Start */}
                        <div className="col-xl-6">
                            <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40">
                                <h6 className="text-xl mb-32">Register</h6>
                                <form onSubmit={registerSubmitHandler}>
                                    <div className="mb-24">
                                        <label
                                            htmlFor="usernameTwo"
                                            className="text-neutral-900 text-lg mb-8 fw-medium"
                                        >
                                            Name <span className="text-danger">*</span>{" "}
                                        </label>
                                        <input
                                            type="text"
                                            className="common-input is-invalid"
                                            id="usernameTwo"
                                            placeholder="Enter your Full name"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                        />
                                        {errors.name && <div className="invalid-feedback">{errors.name && errors.name[0]}</div>}
                                    </div>
                                    <div className="mb-24">
                                        <label
                                            htmlFor="mobile"
                                            className="text-neutral-900 text-lg mb-8 fw-medium"
                                        >
                                            Mobile Number
                                            <span className="text-danger">*</span>{" "}
                                        </label>
                                        <input
                                            type="number"
                                            className="common-input is-invalid"
                                            id="mobile"
                                            placeholder="Enter Mobile Number"
                                            value={registerMobile}
                                            onChange={(e) => setRegisterMobile(e.target.value)}
                                        />
                                        {errors.mobile && <div className="invalid-feedback">{errors.mobile && errors.mobile[0]}</div>}
                                    </div>
                                    <div className="mb-24">
                                        <label
                                            htmlFor="password"
                                            className="text-neutral-900 text-lg mb-8 fw-medium"
                                        >
                                            Password
                                        </label>
                                        <div className="position-relative">
                                            <input
                                                type="password"
                                                className="common-input is-invalid"
                                                id="password"
                                                placeholder="Enter your password"
                                                value={registerPassword}
                                                onChange={(e) => setRegisterPassword(e.target.value)}
                                            />
                                            {errors.registerPassword && <div className="invalid-feedback">{errors.registerPassword && errors.registerPassword[0]}</div>}
                                        </div>
                                    </div>
                                    <div className="mb-24">
                                        <label
                                            htmlFor="confirmpassword"
                                            className="text-neutral-900 text-lg mb-8 fw-medium"
                                        >
                                            Confirm Password
                                        </label>
                                        <div className="position-relative">
                                            <input
                                                type="password"
                                                className="common-input is-invalid"
                                                id="confirmpassword"
                                                placeholder="Enter your password again"
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                            />
                                            {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword && errors.confirmPassword[0]}</div>}
                                        </div>
                                    </div>
                                    <div className="my-48">
                                        <p className="text-gray-500">
                                            Your personal data will be used to process your order, support
                                            your experience throughout this website, and for other purposes
                                            described in our
                                            <Link to="#" className="text-main-600 text-decoration-underline">
                                                {" "}
                                                privacy policy
                                            </Link>
                                            .
                                        </p>
                                    </div>
                                    <div className="mt-48">
                                        <button type="submit" className="btn btn-main py-18 px-40">
                                            Register
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {/* Register Card End */}
                    </div>
            </div>
        </section>

    )
}

export default Account